export const CATEGORIES_REQUEST = 'categories/CATEGORIES_REQUEST';
export const CATEGORIES_SUCCESS = 'categories/CATEGORIES_SUCCESS';
export const CATEGORIES_ERROR = 'categories/CATEGORIES_ERROR';
